var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 4H20.9998C24.85 4 28 7.15 28 11.0002V20.9998C28 24.85 24.85 28 20.9998 28H11.0002C7.15 28 4 24.85 4 20.9998V11.0002C4 7.15 7.15 4 11.0002 4ZM26.0002 11.0002C25.9919 8.24198 23.758 6.00806 20.9998 5.99982H11.0002C8.24198 6.00806 6.00806 8.24198 5.99982 11.0002V20.9998C6.00806 23.758 8.24198 25.9919 11.0002 26.0002H20.9998C23.758 25.9919 25.9919 23.758 26.0002 20.9998V11.0002ZM22.4998 11.0002C21.6714 11.0002 20.9998 10.3286 20.9998 9.50018C20.9998 8.67175 21.6714 8.00018 22.4998 8.00018C23.3282 8.00018 23.9998 8.67175 23.9998 9.50018C24.0007 9.89826 23.8429 10.2803 23.5614 10.5618C23.2799 10.8433 22.8979 11.001 22.4998 11.0002ZM16 10C12.6863 10 10 12.6863 10 16C10 19.3137 12.6863 22 16 22C19.3137 22 22 19.3137 22 16C22 14.4087 21.3679 12.8826 20.2426 11.7574C19.1174 10.6321 17.5913 10 16 10ZM16 11.9998C17.6179 11.9998 19.0765 12.9744 19.6957 14.4692C20.3148 15.964 19.9726 17.6845 18.8286 18.8286C17.6845 19.9726 15.964 20.3148 14.4692 19.6957C12.9744 19.0765 11.9998 17.6179 11.9998 16C12.0022 13.7917 13.7917 12.0022 16 11.9998Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.f7bb82c5a896e81a7ed4a998d6d8dfa2.svg";
export { ForwardRef as ReactComponent };